import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito viajar a EE.UU. para implementar esto?',
    answer: 'No. Todo el proceso puede completarse remotamente como no residente. El ebook explica exactamente cómo hacerlo desde cualquier país.'
  }, {
    question: '¿Sirve para negocios digitales?',
    answer: 'Sí. Este sistema es ideal para consultores, agencias, e-commerce, negocios digitales y cualquier emprendedor que opere internacionalmente.'
  }, {
    question: '¿Esto reemplaza a un CPA o abogado?',
    answer: 'No. Este ebook es educativo y te prepara para trabajar correctamente con profesionales. No es asesoría legal ni fiscal.'
  }, {
    question: '¿Puedo hacerlo como no residente?',
    answer: 'Sí. El sistema está diseñado específicamente para emprendedores hispanos no residentes en EE.UU.'
  }];
  return <section className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-30">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-31">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg overflow-hidden" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between text-left hover:bg-opacity-80 transition-all" aria-expanded={openIndex === index} data-id="element-34">
                <span className="text-base md:text-lg font-semibold text-text-primary pr-3 md:pr-4" data-id="element-35">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`h-5 w-5 md:h-6 md:w-6 text-accent-primary transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-36" />
              </button>

              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="px-4 md:px-6 pb-4 md:pb-6" data-id="element-37">
                  <p className="text-sm md:text-base text-text-secondary leading-relaxed pt-2" data-id="element-38">
                    {faq.answer}
                  </p>
                </motion.div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}